import React, { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput.js";
import DocumentController from "./Controller/document_controller.ts";
import { notification } from "antd";
import FileInput from "../../components/FileInput/FileInput.js";
import SelectInput from "../../components/TextInput/SelectInput.js";
import MultipleSelectChip from "../../components/TextInput/MultipleSelectChip.js";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor.js";
import CustomSeparator from "../../layouts/AdminLayout/Header/Breadcrumbs.js";
import dayjs from "dayjs";
import DefaultDateTimePicker from "../../components/DatePicker/DefaultDateTimePicker.js";
import BasicDatePicker from "../../components/DatePicker/BasicDatePicker.js";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Dashboard = () => {
  const fileInputRef = useRef(null); // Create a ref for the file input
  const [clearFileInput, setClearFileInput] = useState(false);
  const [clearSelectMultipleInput, setClearSelectMultipleInput] =
    useState(false);
  const userID = localStorage.getItem('userID');

  // notification
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, msg) => {
    api[type]({
      message: msg,
      description: desc,
    });
  };
  // encryptor
  const key = "12345";
  const mode = "YMDHI";
  const Encryptor = new InfinityEncryptor(key, mode);

  const required = () => (
    <span style={{ color: "red", marginLeft: "5px", fontSize: "17px" }}>*</span>
  );

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      userID: userID,
      resourcesCategories: "",
      label: "",
      description: "",
      document: "",
      resourcesExpiredDateTime: "",
      resourcesMembershipAccess: "",
      resourcesAccessCommitteeType: "",
      onlyDate: "",
      poster: "",
      author_image: "",
      author_name: "",
      file_label: "",
    },
  });

  const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB in bytes

  const selectedResourcesType = watch("resourcesCategories");
  console.log(selectedResourcesType);

  const calculate13MonthsExpiryDate = () => {
    return dayjs().add(13, "month").format("YYYY-MM-DD HH:mm:ss"); // Local time
  };

  const onSubmit = async (data) => {
    setClearSelectMultipleInput(false);

    const formData = new FormData();
    formData.append("userID" , data.userID);
    formData.append(
      "document_categoryID",
      Encryptor.Encrypt(data.resourcesCategories)
    );
    formData.append("label", Encryptor.Encrypt(data.label));
    formData.append("description", Encryptor.Encrypt(data.description));

    if (data.document && data.document.length > 0) {
      formData.append("file", data.document[0]);
      formData.append("file_label", Encryptor.Encrypt(data.file_label));
    }
    formData.append(
      "document_expired_dateTime",
      Encryptor.Encrypt(
        data.resourcesExpiredDateTime
          ? data.resourcesExpiredDateTime
          : calculate13MonthsExpiryDate()
      )
    );
    formData.append(
      "viewable_member_typeIDs",
      Encryptor.Encrypt(data.resourcesMembershipAccess)
    );
    formData.append(
      "viewable_committee_types",
      Encryptor.Encrypt(data.resourcesAccessCommitteeType)
    );
    formData.append("onlyDate", Encryptor.Encrypt(data.onlyDate));
    if (Object.keys(errors).length > 0) {
      console.log("Form has errors:", errors);
      return; // Prevent submission if there are errors
    }
    console.log(data.onlyDate)
    if (data.author_image && data.author_image.length > 0) {
      formData.append("author_image", data.author_image[0]);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the file input field
    }
    if (data.author_name) {
      formData.append("author_name", Encryptor.Encrypt(data.author_name));
    }
    if (data.poster && data.poster.length > 0) {
      formData.append("poster", data.poster[0]);
    }
    try {
      DocumentController.createDocument(formData).then((response) => {
        console.log(response);
        if (response?.status === "success") {
          reset();
          setClearFileInput((prev) => !prev);
          setClearSelectMultipleInput(true);
          if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Clear the file input field
          }
          openNotificationWithIcon(
            "success",
            "Your data has been saved successfully!",
            "Success"
          );
        }
      });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: "100vh",
        width: "100vw",
      }}
    >
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <CustomSeparator pageName="photo_gallery" />
        {contextHolder}

        <Typography gutterBottom variant="h4" sx={{ color: "text.secondary" }}>
          Upload Photo Gallery
        </Typography>
        <form
          onSubmit={handleSubmit(onSubmit, onInvalid, {
            shouldFocusError: true,
          })}
        >
          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid size={4}>
              <label>Choose Event Category{required()}</label>
            </Grid>
            <Grid size={8}>
              <SelectInput
                type="select"
                {...register("eventCategories", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.eventCategories
                    ? errors.eventCategories.message
                    : ""
                }
                control={control}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid size={4}>
              <label>Choose Event{required()}</label>
            </Grid>
            <Grid size={8}>
              <SelectInput
                type="select"
                {...register("eventList", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.eventList
                    ? errors.eventList.message
                    : ""
                }
                control={control}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid size={4}>
              <label>Upload Image(jpeg,png,jpg)</label>
            </Grid>
            <Grid size={8}>
              <FileInput
                label="Upload Image"
                name="poster"
                control={control}
                rules={{ required: false }}
                helperText={errors.poster && errors.poster.message}
                inputRef={fileInputRef} // Assign the ref to the FileInput component
                onClearInput={clearFileInput}
                {...register("poster", {
                  required: false,
                  validate: (fileList) => {
                    if (
                      fileList &&
                      fileList.length > 0 &&
                      fileList[0].size > MAX_FILE_SIZE
                    ) {
                      return "File size exceeds the 20MB limit.";
                    }
                    return true;
                  },
                })}
              />
            </Grid>
          </Grid>


          <Box textAlign="center" sx={{ paddingBottom: "80px" }}>
            <Button
              sx={{
                borderRadius: "20px",
                mt: 4,
                mb: 4,
                // width: "93.4%",
                height: "48px",
                backgroundColor: "#d33333",
                position: "fixed", // Makes the button fixed
                bottom: "16px", // Position the button 16px from the bottom
                transform: "translateX(-50%)", // Aligns the button in the center
                zIndex: 1000, // Ensures the button stays on top of other elements
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // Floating shadow
                transition: "all 0.3s ease", // Smooth transition for hover effects

                "&:hover": {
                  backgroundColor: "#b02e2e", // Darker red on hover
                  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)", // Larger shadow on hover
                  transform: "translate(-50%, -5px)", // Moves up slightly on hover
                },
              }}
              variant="contained"
              type="submit"
            >
              <Typography variant="h6">Save</Typography>
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default Dashboard;
